import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 7C094780-770D-44B6-981C-C701784192D6
 * name checkbox-blank-circle-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-blank-circle-outline.svg
 * tags
 * - Form 
 */
export const CheckboxBlankCircleOutlineIcon = createSvgIcon(<><path d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></>, 'CheckboxBlankCircleOutlineIcon');
export default CheckboxBlankCircleOutlineIcon